import React, { useState, VFC } from 'react'
import styles from '../../styles/front/form/Form.module.sass'
import FormTemplate from "../form/Common"
import ScrollError from "../form/ScrollError"

type Prefecture = {
  prefecture_name: string,
  prefecture_code: string,
}

type InquiryForm = {
  name: string,
  name_kana: string,
  tel: string,
  email: string,
  zipcode: string,
  prefecture_code: string,
  city_name: string,
  address: string,
  extra_request: string
  project_type?: string
}

type InquiryType = {
  id: number,
  name: string
}

type InquiryFormProps = {
  prefectures: Prefecture[]
  inquiry_form: InquiryForm
  errors?: {[key: string]: string[]}
  terms_path: string
  privacy_path: string
  inquiry_types: InquiryType[]
  theme_color: string
}

const InquiryForm: VFC<InquiryFormProps> = (props: InquiryFormProps) => {
  const {
    prefectures,
    inquiry_form,
    errors,
    terms_path,
    privacy_path,
    inquiry_types,
    theme_color
  } = props

  const [isValidForm, setIsValidForm] = useState(false)

  const [errorMeg, setErrorMeg] = useState("")

  const [isValidInquiryTypes, setIsValidInquiryTypes] = useState(inquiry_types.length == 0)

  function checkSelectTypes() {
    let checkboxes = document.querySelectorAll('input[name^="inquiry[inquiry_types][]"]:checked')
    if (checkboxes.length == 0) {
      setIsValidInquiryTypes(false)
      setErrorMeg("選択してください")
    } else {
      setIsValidInquiryTypes(true)
      setErrorMeg("")
    }
  }

  const handleValueChange = (isValid) => {
    setIsValidForm(isValid);
  };


  function isValidParams() {
    return isValidForm && isValidInquiryTypes
  }

  const [blankCheck, setBlankCheck] = useState(0)

  const scroll = window.innerWidth >= 989 ? 20 : 50

  const checkBlank = (e) =>{
    if(!isValidParams()){
      e.preventDefault()
      checkSelectTypes()
      setBlankCheck(blankCheck + 1)
      setTimeout(() => {
        let firstError =  document.getElementsByClassName("error")[0]
        let rectTop = firstError.getBoundingClientRect().top;
        let positionY = window.pageYOffset;
        let target = rectTop + positionY - scroll
        ScrollError(target)
      }, 10);
    }
  }

  return (
    <>
      <div className={styles.form}>
        {inquiry_types.length > 0 && (
          <div className={styles.inputContainer + ' ' + styles.inquiryType}>
            <label htmlFor="name" className={styles.label}>
              <div className={styles.labelTitle + ' ' + (errorMeg ? ' error' : '')}>お問い合わせ内容</div>
              <div className={styles.labelTag + ' ' + styles.required}>必須</div>
            </label>
            <div className={styles.inputArea}>
              {inquiry_types.map((inquiry_type, index) => (
                <div className={styles.checkBox} key={index}>
                  <input
                    id={`inquiry_inquiry_types_${inquiry_type.id}`}
                    name="inquiry[inquiry_types][]"
                    type="checkbox"
                    className={styles.checkBoxInput}
                    value={inquiry_type.id}
                    onChange={() => checkSelectTypes()}
                  />
                  <label className={styles.checkBoxLabel + ' ' + (errorMeg ? styles.checkBoxErrorInput : '')} htmlFor={`inquiry_inquiry_types_${inquiry_type.id}`}>
                    {inquiry_type.name}
                  </label>
                </div>
              ))}
              {errorMeg && <div className={styles.errorText + ' ' + styles.checkBoxErrorText}>{errorMeg}</div>}
            </div>
          </div>
        )}
        {inquiry_form.project_type && <input type="hidden" name="inquiry[project_type]" value={inquiry_form.project_type} />}
        <FormTemplate
          prefectures={prefectures}
          common_form={inquiry_form}
          errors={errors}
          form_type="inquiry"
          isFormValid={handleValueChange}
          placeHolderText=""
          check={blankCheck}
        />
        <div className={styles.formText}>
          <a href={terms_path} className={styles.link} rel="noopener" target="_blank">利用規約</a>
          と
          <a href={privacy_path} className={styles.link} rel="noopener" target="_blank">プライバシーポリシー</a>
          に同意して
        </div>
        <input type={'hidden'} name="commit" value=""/>
        <div className={styles.spSubmitContainer}>
          <input
            type={'submit'}
            name={'submit'}
            value={`${isValidParams() ? '送信する' : 'まだ入力が完了していません'}`}
            className={`${styles.submitButton} ${isValidParams() ? `${styles.submitButtonAbled} submit-color -${theme_color} -primary` : ""}`}
            onClick={(e)=> checkBlank(e)}
          />
        </div>
      </div>
    </>
  )
}

export default InquiryForm
